import { render, staticRenderFns } from "./CustWebFeature.vue?vue&type=template&id=4789daa0&scoped=true"
import script from "./CustWebFeature.vue?vue&type=script&lang=js"
export * from "./CustWebFeature.vue?vue&type=script&lang=js"
import style0 from "./CustWebFeature.vue?vue&type=style&index=0&id=4789daa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789daa0",
  null
  
)

export default component.exports